// extracted by mini-css-extract-plugin
module.exports = {"playerContainer":"App__playerContainer"};